import {SET_SYSTEM, FETCH_ALL_SYSTEM_REQUEST} from './constants'

export function setSystemState (newSystemState) {
  return {type: SET_SYSTEM, newSystemState}
}

export function fetchAllSystems () {
  return {type: FETCH_ALL_SYSTEM_REQUEST}
}



// WEBPACK FOOTER //
// ./src/actions/system.js